import { render } from "./UploadComponentVale.vue?vue&type=template&id=5027428a&scoped=true"
import script from "./UploadComponentVale.vue?vue&type=script&lang=js"
export * from "./UploadComponentVale.vue?vue&type=script&lang=js"

import "./UploadComponentVale.vue?vue&type=style&index=0&id=5027428a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5027428a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
